import { useState, useEffect } from 'react';
import useSettings from '../hooks/useSettings';
import usePublish from '../hooks/usePublish';

export default function PublishStatus() {
  const settingsApi = useSettings();
  const publishApi = usePublish();
  
  const [settings, setSettings] = useState(null);
  const [settingsLoading, setSettingsLoading] = useState(true);
  const [publishing, setPublishing] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const loadSettings = async () => {
    try {
      const data = await settingsApi.getSettings();
      setSettings(data);
    } catch (err) {
      setError(err);
    } finally {
      setSettingsLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  const handlePublish = async () => {
    setResult(null);
    setError(null);
    setPublishing(true);
    try {
      const response = await publishApi.publish();
      setResult(response);
      await loadSettings();
    } catch (err) {
      setError(err);
    } finally {
      setPublishing(false);
    }
  };

  return (
    <section className="card stack gap-md">
      <div>
        <h2>Publishing</h2>
        <p className="muted">Generate the static website and invalidate the website CloudFront cache.</p>
      </div>
      <div className="stat-card inline">
        <span>Last published</span>
        <strong>{settingsLoading ? '…' : (settings?.lastPublishAt || 'Never')}</strong>
      </div>
      {error ? <div className="alert error">{error.message}</div> : null}
      {result ? (
        <div className="alert success">
          Generated {result.pagesGenerated} pages in {result.durationMs} ms.
          {result.invalidationId ? ` Invalidation: ${result.invalidationId}` : ''}
        </div>
      ) : null}
      {settings?.lastPublishSummary ? (
        <div className="card subtle">
          <strong>Previous summary</strong>
          <pre>{JSON.stringify(settings.lastPublishSummary, null, 2)}</pre>
        </div>
      ) : null}
      <div>
        <button className="button primary" onClick={handlePublish} disabled={publishing}>
          {publishing ? 'Publishing…' : 'Publish site'}
        </button>
      </div>
    </section>
  );
}
